module.exports = __webpack_public_path__ + "img/event-repeat-outline-rounded.93e3b0c6.svg";